import { render, staticRenderFns } from "./ShipmentPage.vue?vue&type=template&id=16f86052&"
import script from "./ShipmentPage.vue?vue&type=script&lang=js&"
export * from "./ShipmentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports